/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Sync_Commit_Message_LabelInputs */

const en_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit Message`)
};

const fr_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message de commit`)
};

const de_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commit-Nachricht`)
};

const it_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Messaggio di commit`)
};

const ru_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение о подтверждении`)
};

const es_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje de confirmación`)
};

const zh_cn2_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交信息`)
};

const ja_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミットメッセージ`)
};

const hi_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिबद्धता संदेश`)
};

const pt_pt2_team_sync_commit_message_label = /** @type {(inputs: Team_Sync_Commit_Message_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem de confirmação`)
};

/**
* | output |
* | --- |
* | "Commit Message" |
*
* @param {Team_Sync_Commit_Message_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_sync_commit_message_label = /** @type {((inputs?: Team_Sync_Commit_Message_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Sync_Commit_Message_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_sync_commit_message_label(inputs)
	if (locale === "de") return de_team_sync_commit_message_label(inputs)
	if (locale === "it") return it_team_sync_commit_message_label(inputs)
	if (locale === "ru") return ru_team_sync_commit_message_label(inputs)
	if (locale === "es") return es_team_sync_commit_message_label(inputs)
	if (locale === "zh-CN") return zh_cn2_team_sync_commit_message_label(inputs)
	if (locale === "ja") return ja_team_sync_commit_message_label(inputs)
	if (locale === "hi") return hi_team_sync_commit_message_label(inputs)
	if (locale === "pt-PT") return pt_pt2_team_sync_commit_message_label(inputs)
	return en_team_sync_commit_message_label(inputs)
});